<template>
    <tr>
        <td class="col-xs-2 text-center">
            <input type="checkbox" :checked="selected" :disabled="disabled" @change.prevent="select">
        </td>

        <td>
            {{ ad.name }}
        </td>

        <td>
            {{ ad.portal.name }}
        </td>

        <td>
            {{ ad.price - ad.agency_commission | price }}
        </td>

        <td>
            <span v-if="status == 'invoiced'" class="label label-success">
                Invoiced
            </span>

            <span v-if="status == 'not-due'" class="label label-warning">
                Not Due
            </span>

            <span v-if="status == 'not-published'" class="label label-warning">
                Not Published
            </span>

            <span v-if="status == 'uninvoiced'" class="label label-info">
                Uninvoiced
            </span>
        </td>
    </tr>
</template>

<script>
    import moment from 'moment'

    export default {
        props: {
            'ad': {},
            'month': {},

            disableInvoicedAds: {
                default: true
            },

            disableUnpublishedAds: {
                default: true
            },

            'selectedBuyables': {}
        },

        computed: {
            selected() {
                return this.selectedBuyables.findIndex(existing => existing === this.ad) > -1
            },

            status() {
                if (this.ad.status === 'invoiced') {
                    return 'invoiced'
                }

                if (!this.due) {
                    return 'not-due'
                }

                if (!this.published) {
                    return 'not-published'
                }

                return this.ad.status
            },

            due() {
                if (!this.month) {
                    return true
                }

                return moment(this.ad.starts_at).format('YYYY-MM') === this.month
            },

            published() {
                return moment(this.ad.starts_at).isBefore()
            },

            disabled() {
                return !this.due || (this.status === 'invoiced' && this.disableInvoicedAds) || (this.status === 'not-published' && this.disableUnpublishedAds)
            }
        },

        methods: {
            select() {
                if (this.selected) {
                    return this.$emit('remove-ad', this.ad)
                }

                return this.$emit('add-ad', this.ad)
            }
        }
    }
</script>
